<template>
  <section>
    <button class="banner">
      <a :href="link">
        <img class="BannerImage" :src="image" alt="" />
      </a>
    </button>
  </section>
</template>
<script>
export default {
  props: { image: String, link: String }
};
</script>
<style>
.BannerImage {
  width: 100%;
  height: 100%;
  border-radius: 30px;
}
</style>
